import { LessonsList } from "../components/teacher/presence/LessonsList"

export const Presence = () => {
    return (
        <div>
            <LessonsList />
        </div>
    )
}